<kendo-dialog *ngIf="dialogSendEmailOpened" (close)="cancel()" [width]="800">
    <kendo-dialog-titlebar>
        <h3>{{ 'SEND-DOCUMENT' | translate }}</h3>
    </kendo-dialog-titlebar>
    <form novalidate [formGroup]="emailForm" class="k-form">
        <div class="mb-3">
            <i class="fas fa-exclamation-triangle fa-2x red">
            </i>
            &nbsp;
            <span class="font-weight-bold">{{ 'PHI-WARNING-EMAIL' | translate }}</span>
        </div>
        <div>
            <label class="k-form-field">
                <span class="k-text-uppercase dark">
                    {{'TO' | translate}} *
                </span>
                <kendo-multiselect [data]="toAddresses" formControlName="to" [allowCustom]="true">
                </kendo-multiselect>
                <div class="k-tooltip k-tooltip-validation" role="alert" *ngIf="to.hasError('required') && to.touched">
                    {{'MESSAGE-TO-ADDRESS-REQUIRED' | translate}}
                </div>
            </label>
        </div>
        <div>
            <label class="k-form-field">
                <span class="k-text-uppercase dark">
                    {{'SUBJECT' | translate}} *
                </span>
                <input id="subject" kendoTextBox formControlName="subject" />
                <div class="k-tooltip k-tooltip-validation" role="alert"
                    *ngIf="subject.hasError('required') && subject.touched">
                    {{'MESSAGE-SUBJECT-REQUIRED' | translate}}
                </div>
            </label>
        </div>
        <div>
            <label class="k-form-field">
                <span class="k-text-uppercase dark">
                    {{'BODY' | translate}} *
                </span>
                <textarea id="body" kendoTextArea rows="3" formControlName="body" class="w-100"></textarea>
                <div class="k-tooltip k-tooltip-validation" role="alert"
                    *ngIf="body.hasError('required') && body.touched">
                    {{'MESSAGE-BODY-REQUIRED' | translate}}
                </div>
            </label>
        </div>
        <div>
            <label class="k-form-field">
                <span class="k-text-uppercase dark">
                    {{'DOCUMENT' | translate}}
                </span>
                {{documentName}}
            </label>
        </div>
    </form>
    <div>* {{'REQUIRED-FIELDS' | translate}}</div>
    <kendo-dialog-actions>
        <button class="k-button" (click)="cancel()">{{ 'CANCEL' | translate }}</button>
        <button appPreventClick kendoButton [primary]="true" (click)="sendEmail($event)" type="button"
            [disabled]="!emailForm.valid || !emailForm.dirty || sendingEmail">
            {{ 'SEND' | translate }}<i class="k-icon k-i-loading" *ngIf="sendingEmail"></i><i *ngIf="!sendingEmail"
                class="fal fa-paper-plane"></i>
        </button>
    </kendo-dialog-actions>
</kendo-dialog>